import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { RootState } from "../store/store";

interface ProtectedRouteProps {
  children: JSX.Element;
  allowedRoles?: string[];
}

const ProtectRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const token = useSelector((state: RootState) => state?.user?.token);
  const userId = useSelector((state: RootState) => state?.user?.id);
  const role = useSelector((state: RootState) => state?.user?.role) as string;
  const location = useLocation();

  if (!token || !userId) {
    return <Navigate to={"/"} state={{ from: location }} />;
  }

  if (allowedRoles && !allowedRoles?.includes(role)) {
    // console.log(allowedRoles);
    return <Navigate to={"/unauthorized"} />;


  }

  return children;
};

export default ProtectRoute;
